import { useState } from "react";
import { useNavigate } from "react-router-dom";

import defaultProfile from "Assets/Common/default_profile.png";

import UseAuth from "Hooks/UseAuth";
import UseNotification from "Hooks/UseNotification";

import Notifications from "Components/Common/Notifications";
import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

import { useTheme } from "styled-components";

const ProfileWidget = ({ onClickOption = () => {} }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const { loadingAuth, authorized } = UseAuth();
  const { logout, parsedJWT } = UseAuth();
  const { hasAlerts } = UseNotification();

  const [openNotifications, setOpenNotifications] = useState(false);

  const [open, setOpen] = useState(false);

  const clickOption = (route) => {
    onClickOption && onClickOption();
    if (route && typeof route === "string") navigate(route);

    setOpen(false);
  };

  const handleOpenNotifications = () => {
    openNotifications
      ? setOpenNotifications(false)
      : setOpenNotifications(true);
  };

  return (
    <S.Wrapper $active={open}>
      {authorized ? (
        <>
          <S.Notifications onClick={handleOpenNotifications}>
            <GetIcon name="Bell" color={theme.colors.neutral.white} />
            {hasAlerts && (
              // `title`: o ponto é só cor e não tem texto próprio — sem um nome
              // acessível ele é invisível para leitor de tela e para teste.
              // Mesma convenção do badge das sessões do projeto.
              <S.NotificationDot title="Há alertas pendentes" />
            )}
          </S.Notifications>

          {openNotifications && (
            <Notifications
              setOpenNotifications={setOpenNotifications}
              isAdmin
            />
          )}
        </>
      ) : null}

      <S.ProfileWrapper $active={open} onClick={() => setOpen(!open)}>
        <S.ProfileBorder>
          <S.ProfileImage
            src={parsedJWT.user.profile_image_src || defaultProfile}
          />
        </S.ProfileBorder>
        <S.InfosWrapper>
          {loadingAuth ? (
            <>
              <S.Name>Carregando...</S.Name>
            </>
          ) : (
            <>
              <S.Name>{parsedJWT.user.full_name}</S.Name>
              <S.Email>{parsedJWT.user.email}</S.Email>
            </>
          )}
        </S.InfosWrapper>
        <GetIcon name="ChevronDown" color={theme.colors.neutral.white} />
      </S.ProfileWrapper>
      {open && (
        <S.OptionsWrapper>
          <S.Option
            onClick={() => {
              clickOption();
              logout();
            }}
          >
            <GetIcon name="Logout" color={theme.colors.neutral.white} />
            Sair
          </S.Option>
        </S.OptionsWrapper>
      )}
    </S.Wrapper>
  );
};

export default ProfileWidget;
